export default {
  RESET_FORUM_EMAIL_TEMPLATE: 'RESET_FORUM_EMAIL_TEMPLATE',
  SAVE_FORUM_EMAIL_TEMPLATE_REQUEST: (identifier = '') => `SAVE_FORUM_EMAIL_TEMPLATE_REQUEST_${identifier.toUpperCase()}`,
  SAVE_FORUM_EMAIL_TEMPLATE_SUCCESS: (identifier = '') => `SAVE_FORUM_EMAIL_TEMPLATE_SUCCESS_${identifier.toUpperCase()}`,
  SAVE_FORUM_EMAIL_TEMPLATE_FAILURE: (identifier = '') => `SAVE_FORUM_EMAIL_TEMPLATE_FAILURE_${identifier.toUpperCase()}`
}
